"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns the catalog item's id for the provided code. Most of the time
 * relationships are saved with the "code" value, but api endpoints that
 * filter by an entity require said entity's id to be provided.
 * Example: the vehicle stored in the quotation saves the codes for brand
 * and model in the "brandId" and "modelId" fields (lol), but to get their
 * complete data you need to query each of their catalogs and filter. To get
 * a list of models, you need to provide a brandId, but you currently only have
 * access to the code just by looking at the data inside the quotation.
 *
 * If no item is found for the provided code, return -1.
 *
 * @param items - The list of CatalogItems to search
 * @param code - The code that will be searched for
 */
function catalogIdForCode(items, code) {
    var foundItem = items.filter(function (item) { return item.code === code; }).pop();
    if (foundItem) {
        return foundItem.id;
    }
    return -1;
}
exports.default = catalogIdForCode;
//# sourceMappingURL=catalogIdForCode.js.map